import { Incident } from '@/types/community/incident';

// Helper function to get dates relative to current date
function getRelativeDate(daysOffset: number, hour: number = 9, minute: number = 0): Date {
  const date = new Date();
  date.setDate(date.getDate() + daysOffset);
  date.setHours(hour, minute, 0, 0);
  return date;
}

export const incidents: Incident[] = [
  // Recent incidents (last few days)
  {
    id: 'INC001',
    title: 'Water Leak in Common Area',
    description: 'Water leaking from ceiling in the lobby area',
    type: 'safety',
    priority: 'high',
    status: 'investigating',
    reportedBy: {
      id: 'EMP001',
      name: 'Security Guard',
      type: 'employee'
    },
    reportedAt: getRelativeDate(-1, 8, 0),
    assignedTo: {
      id: 'EMP002',
      name: 'Maintenance Team'
    },
    attachments: [
      {
        id: 'ATT001',
        name: 'leak_photo.jpg',
        type: 'image/jpeg',
        size: 2048,
        path: '/documents/incidents/INC001/leak_photo.jpg',
        url: 'https://example.com/photos/leak.jpg',
        uploadedAt: getRelativeDate(-1, 8, 0)
      }
    ],
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC002',
    title: 'Broken Elevator',
    description: 'Elevator in Block A is not functioning properly',
    type: 'other',
    priority: 'high',
    status: 'investigating',
    reportedBy: {
      id: 'RES001',
      name: 'John Doe',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-2, 10, 0),
    assignedTo: {
      id: 'EMP003',
      name: 'Maintenance Staff'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC003',
    title: 'Suspicious Activity',
    description: 'Suspicious person loitering in parking area',
    type: 'security',
    priority: 'medium',
    status: 'resolved',
    reportedBy: {
      id: 'EMP004',
      name: 'Security Guard',
      type: 'employee'
    },
    reportedAt: getRelativeDate(-3, 22, 0),
    resolvedAt: getRelativeDate(-2, 0, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC004',
    title: 'Power Outage',
    description: 'Power outage affecting Block B',
    type: 'other',
    priority: 'high',
    status: 'investigating',
    reportedBy: {
      id: 'RES002',
      name: 'Jane Smith',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-4, 15, 0),
    assignedTo: {
      id: 'EMP002',
      name: 'Maintenance Team'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC005',
    title: 'Noise Complaint',
    description: 'Excessive noise from apartment 3B',
    type: 'noise',
    priority: 'low',
    status: 'investigating',
    reportedBy: {
      id: 'RES003',
      name: 'Mike Johnson',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-5, 23, 0),
    assignedTo: {
      id: 'EMP001',
      name: 'Security Guard'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },

  // Past week incidents
  {
    id: 'INC006',
    title: 'Broken Window',
    description: 'Broken window in common area',
    type: 'other',
    priority: 'medium',
    status: 'investigating',
    reportedBy: {
      id: 'EMP003',
      name: 'Maintenance Staff',
      type: 'employee'
    },
    reportedAt: getRelativeDate(-6, 9, 0),
    assignedTo: {
      id: 'EMP003',
      name: 'Maintenance Staff'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC007',
    title: 'Fire Alarm Test',
    description: 'Scheduled fire alarm system test',
    type: 'safety',
    priority: 'low',
    status: 'reported',
    reportedBy: {
      id: 'EMP004',
      name: 'Security Guard',
      type: 'employee'
    },
    reportedAt: getRelativeDate(-7, 8, 0),
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC008',
    title: 'Pool Maintenance',
    description: 'Pool filter system malfunction',
    type: 'maintenance',
    priority: 'medium',
    status: 'resolved',
    reportedBy: {
      id: 'EMP005',
      name: 'Pool Attendant',
      type: 'employee'
    },
    reportedAt: getRelativeDate(-8, 7, 0),
    resolvedAt: getRelativeDate(-8, 12, 0),
    assignedTo: {
      id: 'EMP003',
      name: 'Maintenance Staff'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC009',
    title: 'Unauthorized Vehicle',
    description: 'Unauthorized vehicle parked in resident spot',
    type: 'security',
    priority: 'medium',
    status: 'investigating',
    reportedBy: {
      id: 'EMP001',
      name: 'Security Guard',
      type: 'employee'
    },
    reportedAt: getRelativeDate(-9, 16, 0),
    assignedTo: {
      id: 'EMP001',
      name: 'Security Guard'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC010',
    title: 'Internet Outage',
    description: 'Internet service down in Block C',
    type: 'maintenance',
    priority: 'high',
    status: 'in_progress',
    reportedBy: {
      id: 'RES004',
      name: 'Sarah Wilson',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-10, 14, 0),
    assignedTo: {
      id: 'EMP002',
      name: 'Maintenance Team'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },

  // Past month incidents
  {
    id: 'INC011',
    title: 'HVAC System Failure',
    description: 'Heating system not working in Block A',
    type: 'maintenance',
    priority: 'high',
    status: 'resolved',
    reportedBy: {
      id: 'RES005',
      name: 'David Brown',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-15, 6, 0),
    resolvedAt: getRelativeDate(-14, 18, 0),
    assignedTo: {
      id: 'EMP002',
      name: 'Maintenance Team'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC012',
    title: 'Gas Leak Detection',
    description: 'Gas leak detected in apartment 2C',
    type: 'safety',
    priority: 'critical',
    status: 'resolved',
    reportedBy: {
      id: 'RES006',
      name: 'Lisa Davis',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-18, 19, 0),
    resolvedAt: getRelativeDate(-18, 22, 0),
    assignedTo: {
      id: 'EMP002',
      name: 'Maintenance Team'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC013',
    title: 'Mailbox Vandalism',
    description: 'Mailboxes damaged in lobby',
    type: 'security',
    priority: 'medium',
    status: 'resolved',
    reportedBy: {
      id: 'EMP001',
      name: 'Security Guard',
      type: 'employee'
    },
    reportedAt: getRelativeDate(-20, 8, 0),
    resolvedAt: getRelativeDate(-19, 14, 0),
    assignedTo: {
      id: 'EMP003',
      name: 'Maintenance Staff'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC014',
    title: 'Loud Party Complaint',
    description: 'Excessive noise from apartment 4A',
    type: 'noise',
    priority: 'high',
    status: 'resolved',
    reportedBy: {
      id: 'RES007',
      name: 'Tom Wilson',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-22, 22, 0),
    resolvedAt: getRelativeDate(-22, 23, 0),
    assignedTo: {
      id: 'EMP001',
      name: 'Security Guard'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC015',
    title: 'Electrical Panel Issue',
    description: 'Electrical panel malfunction in basement',
    type: 'maintenance',
    priority: 'high',
    status: 'resolved',
    reportedBy: {
      id: 'EMP003',
      name: 'Maintenance Staff',
      type: 'employee'
    },
    reportedAt: getRelativeDate(-25, 10, 0),
    resolvedAt: getRelativeDate(-24, 16, 0),
    assignedTo: {
      id: 'EMP002',
      name: 'Maintenance Team'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },

  // Older incidents
  {
    id: 'INC016',
    title: 'Car Damage in Parking',
    description: 'Car scratched in parking lot',
    type: 'security',
    priority: 'medium',
    status: 'resolved',
    reportedBy: {
      id: 'RES008',
      name: 'Emma Thompson',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-30, 16, 0),
    resolvedAt: getRelativeDate(-29, 10, 0),
    assignedTo: {
      id: 'EMP001',
      name: 'Security Guard'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC017',
    title: 'Plumbing Emergency',
    description: 'Major plumbing issue in apartment 1B',
    type: 'maintenance',
    priority: 'critical',
    status: 'resolved',
    reportedBy: {
      id: 'RES009',
      name: 'Alex Rodriguez',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-35, 7, 0),
    resolvedAt: getRelativeDate(-33, 20, 0),
    assignedTo: {
      id: 'EMP002',
      name: 'Maintenance Team'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC018',
    title: 'Roof Leak',
    description: 'Water leaking from roof in Block C',
    type: 'maintenance',
    priority: 'high',
    status: 'resolved',
    reportedBy: {
      id: 'RES010',
      name: 'Maria Garcia',
      type: 'resident'
    },
    reportedAt: getRelativeDate(-40, 9, 0),
    resolvedAt: getRelativeDate(-38, 17, 0),
    assignedTo: {
      id: 'EMP003',
      name: 'Maintenance Staff'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC019',
    title: 'Fire Alarm Malfunction',
    description: 'False fire alarm triggered',
    type: 'safety',
    priority: 'medium',
    status: 'resolved',
    reportedBy: {
      id: 'EMP004',
      name: 'Security Guard',
      type: 'employee'
    },
    reportedAt: getRelativeDate(-45, 14, 0),
    resolvedAt: getRelativeDate(-45, 15, 0),
    assignedTo: {
      id: 'EMP002',
      name: 'Maintenance Team'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'INC020',
    title: 'Trash Disposal Violation',
    description: 'Resident not following trash disposal rules',
    type: 'other',
    priority: 'low',
    status: 'resolved',
    reportedBy: {
      id: 'EMP005',
      name: 'Cleaning Staff',
      type: 'employee'
    },
    reportedAt: getRelativeDate(-50, 11, 0),
    resolvedAt: getRelativeDate(-49, 13, 0),
    assignedTo: {
      id: 'EMP001',
      name: 'Security Guard'
    },
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  }
]; 